<template>
  <div class="api-tester">
    <h1>{{ service.name }}</h1>
    <!-- 新增：接口基础信息面板 -->
    <div class="info-panel">
      <h3>基础信息</h3>
      <ul class="info-list">
        <li class="info-item">
          <span class="info-icon">📝</span>
          <span class="info-label">接口介绍：</span>
          <span class="info-value">{{service.description}}</span>
        </li>
<!--        <li class="info-item">-->
<!--          <span class="info-icon">📅</span>-->
<!--          <span class="info-label">上架时间：</span>-->
<!--          <span class="info-value">2024/11/9 13:30:51</span>-->
<!--        </li>-->
        <li class="info-item">
          <span class="info-icon">💰</span>
          <span class="info-label">是否收费：</span>
          <span class="info-value"><span class="tag">{{service.price}}</span></span>
        </li>
        <li class="info-item">
          <span class="info-icon">🔗</span>
          <span class="info-label">接口地址：</span>
          <span class="info-value link">{{service.endpoint}}</span>
        </li>
        <li class="info-item">
          <span class="info-icon">📤</span>
          <span class="info-label">请求方式：</span>
          <span class="info-value">POST</span>
        </li>
        <li class="info-item">
          <span class="info-icon">📦</span>
          <span class="info-label">返回格式：</span>
          <span class="info-value">JSON</span>
        </li>
        <li class="info-item">
          <span class="info-icon">📋</span>
          <span class="info-label">请求示例：</span>
          <span class="info-value link">{{service.endpoint}}</span>
        </li>
      </ul>

      <!-- 新增：请求参数表格 -->
      <div class="params-table-section">
        <h3>请求参数</h3>
        <table class="params-table">
          <thead>
            <tr>
              <th>参数名</th>
              <th>必选</th>
              <th>类型</th>
              <th>说明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="param in service.params" :key="param.name">
              <td>{{ param.name }}</td>
              <td>{{ param.required }}</td>
              <td>{{ param.type }}</td>
              <td>{{ param.description }}</td>
            </tr>
          </tbody>
        </table>

<!--      <div class="params-panel" >-->
<!--        <h3>请求样例</h3>-->
<!--        <textarea v-model="requestBody" placeholder="输入 JSON 格式的请求体" class="params-input"></textarea>-->

<!--      </div>-->




      </div>


<!--      <div class="params-table-section">-->
<!--        <h3>返回参数</h3>-->
<!--        <table class="params-table">-->
<!--          <thead>-->
<!--          <tr>-->
<!--            <th>参数名</th>-->
<!--            <th>必选</th>-->
<!--            <th>类型</th>-->
<!--            <th>说明</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr>-->
<!--            <td>domain</td>-->
<!--            <td>是</td>-->
<!--            <td>string</td>-->
<!--            <td>服务器域名/IP地址</td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->

        <!--      <div class="params-panel" >-->
        <!--        <h3>请求样例</h3>-->
        <!--        <textarea v-model="requestBody" placeholder="输入 JSON 格式的请求体" class="params-input"></textarea>-->

        <!--      </div>-->




<!--      </div>-->
    </div>
<!--    <h1>在线接口测试</h1>-->
<!--    <div class="request-panel">-->
<!--      <div class="method-url">-->
<!--        <select v-model="method" class="method-select">-->
<!--          <option>GET</option>-->
<!--          <option>POST</option>-->
<!--        </select>-->
<!--        <input type="text" v-model="url" placeholder="输入请求URL" class="url-input"/>-->
<!--      </div>-->

<!--      <div class="params-panel" v-if="method !== 'GET'">-->
<!--        <h3>请求参数</h3>-->
<!--        <textarea v-model="requestBody" placeholder="输入 JSON 格式的请求体" class="params-input"></textarea>-->
<!--      </div>-->

<!--      <button @click="sendRequest" class="send-btn">发送请求</button>-->

<!--      <div class="response-panel">-->
<!--        <h3>响应结果</h3>-->
<!--        <pre class="response-area">{{ response }}</pre>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'AboutView',
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      method: 'GET',
      url: '',
      requestBody: '',
      response: ''
    }
  },
  methods: {
    async sendRequest() {
      try {
        const options = {
          method: this.method,
          headers: {
            'Content-Type': 'application/json'
          }
        }

        if (this.method !== 'GET' && this.requestBody) {
          options.body = this.requestBody
        }

        const res = await fetch(this.url, options)
        const data = await res.json()
        this.response = JSON.stringify(data, null, 2)
      } catch (error) {
        this.response = `错误: ${error.message}`
      }
    }
  }
}
</script>

<style scoped>
.api-tester {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.request-panel {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
}

.method-url {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.method-select {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background: #fff;
}

.url-input {
  flex: 1;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.params-panel {
  margin: 20px 0;
}

.params-input {
  width: 100%;
  height: 150px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.send-btn {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.send-btn:hover {
  background: #45a049;
}

.response-panel {
  margin-top: 20px;
}

.response-area {
  background: #fff;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #ddd;
  min-height: 150px;
  white-space: pre-wrap;
}

/* 新增样式 */
.info-panel {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.info-item {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.info-item h3 {
  color: #333;
  margin-bottom: 8px;
  font-size: 1rem;
}

.info-item p {
  color: #666;
  margin: 0;
}

.example-section {
  margin: 20px 0;
}

.code-block {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  font-family: monospace;
  overflow-x: auto;
}

.params-table-section {
  margin: 20px 0;
}

.params-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.params-table th,
.params-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.params-table th {
  background: #f5f5f5;
  font-weight: bold;
}

.params-table tr:nth-child(even) {
  background: #f9f9f9;
}

h2 {
  color: #333;
  margin-bottom: 20px;
}

h3 {
  color: #444;
  margin: 15px 0;
}


.info-panel {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-item {
  padding: 12px 0;
  display: flex;
  align-items: center;
  line-height: 1.6;
  color: #333;
}

.info-icon {
  margin-right: 8px;
  font-size: 16px;
  width: 24px;
  text-align: center;
}

.info-label {
  color: #666;
  margin-right: 8px;
}

.info-label {
  color: #666;
  margin-right: 8px;
  width: 100px; /* 添加固定宽度 */
  flex-shrink: 0; /* 防止标签宽度被压缩 */
}

.info-value {
  flex: 1;
  text-align: left; /* 确保左对齐 */
  margin-left: 0; /* 移除可能的左边距 */
  padding-left: 0; /* 移除可能的左内边距 */
}

.link {
  color: #1890ff;
  text-decoration: none;
  cursor: pointer;
}

.tag {
  background: #f0f0f0;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

h2 {
  font-size: 18px;
  font-weight: 500;
  margin: 20px 0;
  color: #333;
}

.params-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
}

.params-table th,
.params-table td {
  padding: 12px;
  text-align: left;
  border: 1px solid #f0f0f0;
}

.params-table th {
  background: #fafafa;
  font-weight: 500;
}

.params-table tr:hover {
  background: #fafafa;
}
</style>
